// Root
export const ROOT_UPDATE_STATE = 'ROOT_UPDATE_STATE'
export const ROOT_ADD_MESSAGE = 'ROOT_ADD_MESSAGE'
export const ROOT_DISMISS_MESSAGE = 'ROOT_DISMISS_MESSAGE'
